import { default as aboutF5uTozYvL4Meta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/about.vue?macro=true";
import { default as cartBtJtmPfGrvMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/cart.vue?macro=true";
import { default as checkoutvvqJKKRiyrMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/checkout.vue?macro=true";
import { default as coming_45soonuPhwDARW56Meta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/coming-soon.vue?macro=true";
import { default as contactqdz3SrbW7dMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/contact.vue?macro=true";
import { default as contactV1aSZySfvOqAMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/contactV1.vue?macro=true";
import { default as detailsSqR3jYY5OQMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/details.vue?macro=true";
import { default as indexhwOhKXT7baMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/index.vue?macro=true";
import { default as ordersbQlNQGdLUEMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/orders.vue?macro=true";
import { default as outlets4x4GGr1yCCMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/outlets.vue?macro=true";
import { default as cancelz1s4x3Q05iMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/payments/response/cancel.vue?macro=true";
import { default as failedHOAuwSxLTWMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/payments/response/failed.vue?macro=true";
import { default as latercLqfue9IvwMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/payments/response/later.vue?macro=true";
import { default as successl6Bk4bGopkMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/payments/response/success.vue?macro=true";
import { default as privacy_45policyO5YxWUbak7Meta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/privacy-policy.vue?macro=true";
import { default as _91id_93Lt36lnxRjAMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/products/[id].vue?macro=true";
import { default as indexbo521WqhMpMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/products/index.vue?macro=true";
import { default as profileafnQf4tQmgMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/profile.vue?macro=true";
import { default as returnKRo4zdrRpHMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/return.vue?macro=true";
import { default as terms_45conditions95zBbcw0iUMeta } from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/terms-conditions.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/cart.vue").then(m => m.default || m)
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkoutvvqJKKRiyrMeta || {},
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "coming-soon",
    path: "/coming-soon",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/coming-soon.vue").then(m => m.default || m)
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: "contactV1",
    path: "/contactV1",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/contactV1.vue").then(m => m.default || m)
  },
  {
    name: "details",
    path: "/details",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/details.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/orders.vue").then(m => m.default || m)
  },
  {
    name: "outlets",
    path: "/outlets",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/outlets.vue").then(m => m.default || m)
  },
  {
    name: "payments-response-cancel",
    path: "/payments/response/cancel",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/payments/response/cancel.vue").then(m => m.default || m)
  },
  {
    name: "payments-response-failed",
    path: "/payments/response/failed",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/payments/response/failed.vue").then(m => m.default || m)
  },
  {
    name: "payments-response-later",
    path: "/payments/response/later",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/payments/response/later.vue").then(m => m.default || m)
  },
  {
    name: "payments-response-success",
    path: "/payments/response/success",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/payments/response/success.vue").then(m => m.default || m)
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/products/[id].vue").then(m => m.default || m)
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/profile.vue").then(m => m.default || m)
  },
  {
    name: "return",
    path: "/return",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/return.vue").then(m => m.default || m)
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    component: () => import("/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/pages/terms-conditions.vue").then(m => m.default || m)
  }
]